import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/**
 * "You do not have access to this page — ask the shop owner" (T11-01): shown for a direct URL to a
 * screen the role cannot use. Plain language, no permission names.
 */
export function ForbiddenState() {
  const { t } = useTranslation();
  return (
    <section
      role="alert"
      data-slot="forbidden"
      className="flex flex-col items-start gap-3 rounded-lg border p-6"
    >
      <ShieldAlert className="size-8 text-status-problem" aria-hidden />
      <h1 className="text-xl font-bold">{t("auth.forbidden_title")}</h1>
      <p className="text-muted-foreground">{t("auth.forbidden_body")}</p>
      <Link to="/" className="min-h-touch inline-flex items-center underline underline-offset-4">
        {t("errors.back_home")}
      </Link>
    </section>
  );
}
